import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';

export class GenContainer extends TrackableEntity {
    id: number = 0;
    genMainId: number = 0;
    containerNo: string = '';
    conType: string = '';
    sealNo: string = '';
    pkgs: number = 0;

    bookingDate: string | null = null;
    bookingLoc: string = '';

    ord: string | null = null;
    ordLoc: string = '';
    
    inDate: string | null = null;
    inDateLoc: string = '';
    
    loadDate: string | null = null;
    loadDateLoc: string = '';

    atd: string | null = null;
    atdLoc: string = '';

    ata: string | null = null;
    ataLoc: string = '';

    unloadDate: string | null = null;
    unloadDateLoc: string = '';

    carrierRls: string | null = null;
    carrierRlsLoc: string = '';

    customRls: string | null = null;
    customRlsLoc: string = '';
    
    rAtd: string | null = null;
    rAtdLoc: string = '';

    rAta: string | null = null;
    rAtaLoc: string = '';

    cfsDate: string | null = null;
    cfsDateLoc: string = '';

    puDate: string | null = null;
    puDateLoc: string = '';

    outDate: string | null = null;
    outDateLoc: string = '';

    dcDate: string | null = null;
    dcDateLoc: string = '';

    emptyReturn: string | null = null;
    emptyReturnLoc: string = '';

    // UI
    select: boolean = false;

    constructor(init?:Partial<GenContainer>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('id');
        if(this.id === 0) this.id = this.GetNextId();
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        return GenContainer.dicFieldMappings;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_Id', table: 'T_GENCONTAINER' }),
        'containerNo': new DBMappingInfo({ field: 'F_ContainerNo', table: 'T_GENCONTAINER' }),
        'conType': new DBMappingInfo({ field: 'F_ConType', table: 'T_GENCONTAINER' }),
        'sealNo': new DBMappingInfo({ field: 'F_SealNo', table: 'T_GENCONTAINER' }),
        'pkgs': new DBMappingInfo({ field: 'F_Pkgs', table: 'T_GENCONTAINER' }),
        'genMainId': new DBMappingInfo({ field: 'F_GenMainId', table: 'T_GENCONTAINER' }),
        'bookingDate': new DBMappingInfo({ field: 'f_bookingdate', table: 'T_GENCONTAINER' }),
        'bookingLoc': new DBMappingInfo({ field: 'f_booking_loc', table: 'T_GENCONTAINER' }),
        'ord': new DBMappingInfo({ field: 'f_ord', table: 'T_GENCONTAINER' }),
        'ordLoc': new DBMappingInfo({ field: 'f_ord_loc', table: 'T_GENCONTAINER' }),
        'inDate': new DBMappingInfo({ field: 'F_InDate', table: 'T_GENCONTAINER' }),
        'inDateLoc': new DBMappingInfo({ field: 'f_indate_loc', table: 'T_GENCONTAINER' }),
        'loadDate': new DBMappingInfo({ field: 'f_loaddate', table: 'T_GENCONTAINER' }),
        'loadDateLoc': new DBMappingInfo({ field: 'f_loaddate_loc', table: 'T_GENCONTAINER' }),
        'atd': new DBMappingInfo({ field: 'f_atd', table: 'T_GENCONTAINER' }),
        'atdLoc': new DBMappingInfo({ field: 'f_atd_loc', table: 'T_GENCONTAINER' }),
        'ata': new DBMappingInfo({ field: 'f_ata', table: 'T_GENCONTAINER' }),
        'ataLoc': new DBMappingInfo({ field: 'f_ata_loc', table: 'T_GENCONTAINER' }),
        'unloadDate': new DBMappingInfo({ field: 'f_unloaddate', table: 'T_GENCONTAINER' }),
        'unloadDateLoc': new DBMappingInfo({ field: 'f_unloaddate_loc', table: 'T_GENCONTAINER' }),
        'carrierRls': new DBMappingInfo({ field: 'f_carrierrls', table: 'T_GENCONTAINER' }),
        'carrierRlsLoc': new DBMappingInfo({ field: 'f_carrierrls_loc', table: 'T_GENCONTAINER' }),
        'customRls': new DBMappingInfo({ field: 'f_customrls', table: 'T_GENCONTAINER' }),
        'customRlsLoc': new DBMappingInfo({ field: 'f_customrls_loc', table: 'T_GENCONTAINER' }),
        'cfsDate': new DBMappingInfo({ field: 'f_cfsdate', table: 'T_GENCONTAINER' }),
        'cfsDateLoc': new DBMappingInfo({ field: 'f_cfsdate_loc', table: 'T_GENCONTAINER' }),
        'rAtd': new DBMappingInfo({ field: 'f_ratd', table: 'T_GENCONTAINER' }),
        'rAtdLoc': new DBMappingInfo({ field: 'f_ratd_loc', table: 'T_GENCONTAINER' }),
        'rAta': new DBMappingInfo({ field: 'f_rata', table: 'T_GENCONTAINER' }),
        'rAtaLoc': new DBMappingInfo({ field: 'f_rata_loc', table: 'T_GENCONTAINER' }),
        'puDate': new DBMappingInfo({ field: 'f_pudate', table: 'T_GENCONTAINER' }),
        'puDateLoc': new DBMappingInfo({ field: 'f_pudate_loc', table: 'T_GENCONTAINER' }),
        'outDateLoc': new DBMappingInfo({ field: 'f_outdate_loc', table: 'T_GENCONTAINER' }),
        'outDate': new DBMappingInfo({ field: 'F_OutDate', table: 'T_GENCONTAINER' }),
        'dcDate': new DBMappingInfo({ field: 'f_dcdate', table: 'T_GENCONTAINER' }),
        'dcDateLoc': new DBMappingInfo({ field: 'f_dcdate_loc', table: 'T_GENCONTAINER' }),
        'emptyReturn': new DBMappingInfo({ field: 'F_EmptyReturn', table: 'T_GENCONTAINER' }),
        'emptyReturnLoc': new DBMappingInfo({ field: 'f_emptyreturn_loc', table: 'T_GENCONTAINER' }),
    };
}
